.truncation-icon {
  color: var(--dds-color-icon-medium);
  min-width: calc(1ch + (2 * var(--dds-spacing-x0-75)));
}
